import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { TourRouteNotifier } from './tour-route-notifier';
import { TourRouteState } from './tour-route-state';

@Injectable()
export class TourRouteProvider extends BaseProvider<TourRouteNotifier, TourRouteState> {
  constructor() {
    super(TourRouteNotifier);
  }
}
